import React from 'react';
import graphql from 'graphql';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import Content, { HTMLContent } from '../components/Content';
import Team from '../components/Team';
import ResourceList from '../components/ResourceList';
import Contact from '../components/Contact';
import Sections from '../components/Sections';

export const AboutPageTemplate = ({ title, headerImage, headerTitle,  content, contentComponent, sections, team, resources }) => {
  const PageContent = contentComponent || Content;

  return (
    <div>
      <Helmet
        title={ "San Juan Software | " + title }
      />
      <section className="hero header-image-hero sub-page-hero">
        <div className="hero-body" style={{backgroundImage: 'url('+headerImage+')' }}>
            <h1 className="title">
              <span className="type-it">{headerTitle}</span>
            </h1>
        </div>
      </section>
      <section className="hero hero-bar is-primary">
      </section>
      <section id={'vision-and-values'} className="section section--gradient">
        <div className="container">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <div className="section content">
                <PageContent content={content} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="company" className="section content is-sjs-white-smoke">
        <div className="container">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <div className="columns">
                <div className="column is-6">
                  <figure style={{float:'right', margin: '0', textAlign: 'right'}} className="image">
                    <img src="/img/about/CES.jpg" />
                    <p><em>Tim Gillman and Drew Gislason answer questions at the ZigBee booth at CES</em></p>
                  </figure>
                </div>
                <div className="column is-6">
                    <h2>The Company</h2>
                    <p>Over the past 15 years San Juan Software has worked closely with semiconductor companies and standards organizations to create and improve wired and wireless communications protocols that form a backbone of the internet of Things. Through products, training and services to Original Equipment Manufacturers (OEMs) San Juan Software promotes the widespread adoption of wired and wireless sensor networks for the Internet of Things (IoT) and Aerospace.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id='management-team' className="section content section--gradient">
        <div className="container">
          <div className="columns">
            <div className="column is-10 is-offset-1">
              <Team members={team.members} />
            </div>
          </div>
        </div>
      </section>
      <section className="hero is-secondary">
        <div className="hero-body">
          <div className="container">
            <div className="columns">
              <div className="column is-10 is-offset-1">
                <div className="section content">
                  <ResourceList resources={resources} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="hero is-sjs-white-smoke">
        <div className="hero-body">
          <div className="container">
            <div className="columns">
              <div className="column is-10 is-offset-1">
                <div className="section content">
                  <div className="resource">
                    <div className="columns is-v-centered">
                      <div className="column is-6" style={{textAlign: 'right'}}>
                        <h3>Drew attended and now is an instructor at the University of Washington.</h3>
                      </div>
                      <div className="column is-6">
                        <a href="https://www.pce.uw.edu/certificates/internet-of-things" target="_blank"><img src="/img/about/uw-professional-logo.jpg"/></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="hero is-sjs-dark-gray">
        <div className="hero-body">
          <div className="container">
            <div className="columns">
              <div className="column is-10 is-offset-1">
                <div className="section content has-text-centered">
                  <h2 className="has-text-centered">Are you interested in joining our team?<br /><br /></h2>
                  <Link className="button is-large is-sjs-yellow" to="/careers">Careers</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Contact />
    </div>
  );
};

export default ({ data }) => {
  const { frontmatter, html } = data.markdownRemark;
   
  return (<AboutPageTemplate
    contentComponent={HTMLContent}
    title={frontmatter.title}
    headerImage={frontmatter.headerImage}
    headerTitle={frontmatter.headerTitle}
    content={html}
    sections={frontmatter.sections}
    team={frontmatter.team}
    resources={frontmatter.resources}
  />);
};

export const aboutPageQuery = graphql`
  query AboutPage($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
    	frontmatter {
        path
        title
        headerImage
        headerTitle
        sections {
          image
          title
          description
        }
        team {
          members {
            name
            title
            photo
          	bio
          }
        }
        resources {
          link
          photo
          testimonial
          author
        }
        careers {
          title
          description
        }
      }
    }
  }
`;
 



// WEBPACK FOOTER //
// ./src/templates/about-page.js